
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { getDocumentUrlFromId } from "@/lib/wordpress/load";
import { configStore } from "@/store/store-accessor";
import Dialog from "@/components/UI/Dialog.vue";

@Component({
  components: { Dialog }
})
export default class TemplateDialog extends Vue {
  @Prop()
  templateName!: string;

  @Prop()
  templateId!: number;

  @Prop()
  templateIsFallback!: boolean;

  @Prop()
  templatesPageUrl!: string;

  get decodedTemplateName() {
    const txt = document.createElement("textarea");
    txt.innerHTML = this.templateName;
    return txt.value;
  }

  get templateUrl() {
    return getDocumentUrlFromId(this.templateId);
  }

  get backToAdmin() {
    if (configStore.documentSpecificNeededUrls) {
      return configStore.documentSpecificNeededUrls.backToWordPressUrl ?? "";
    }

    return "";
  }
}
